import { useCallback, useEffect } from 'react';
import { useFocusEffect, useNavigation } from 'expo-router';

/**
 * We are disabling gestures when the animated dialog is shown, as we don't want users to dismiss the bag when attempting to dismiss it.
 * When the screen is unfocused, we re-enable the gestures so it doesn't break other screens in the modal stack.
 */
export const useBagGestures = (isShowingModal: boolean) => {
  const navigation = useNavigation();

  useEffect(() => {
    navigation.getParent()?.setOptions({ gestureEnabled: !isShowingModal });
  }, [navigation, isShowingModal]);

  useFocusEffect(
    useCallback(() => {
      return () => {
        navigation.getParent()?.setOptions({ gestureEnabled: true });
      };
    }, [navigation]),
  );
};
